import styled from "styled-components"

import IconBase from "@irati/ui/src/Icon"
import {Label} from "@irati/ui/src/Typography"

export interface TextHelperProps {
  small?: boolean
}

export const Icon = styled(IconBase)`
  margin-right: ${({theme}) => theme.spacing.one};
`

export const TextHelper = styled(Label)<TextHelperProps>`
  display: inline-flex;
  align-items: center;
  line-height: 1;
`
